import { useBitrixStore } from '@/shared/store/useBitrixStore';

/**
 * @deprecated legacy
 */
export namespace bitrixStoreService {
  /**
   * @deprecated legacy
   */
  export async function getClientId() {
    const bitrixStore = useBitrixStore();
    return bitrixStore.clientId;
  }

  /**
   * @deprecated legacy
   */
  export async function getClientChangeEmail() {
    const bitrixStore = useBitrixStore();
    return bitrixStore.changeClientEmail;
  }

  /**
   * @deprecated legacy
   */
  export async function getClientEmail() {
    const bitrixStore = useBitrixStore();
    return bitrixStore.clientEmail;
  }

  /**
   * @deprecated legacy
   */
  export async function getClientChangeCode() {
    const bitrixStore = useBitrixStore();
    return bitrixStore.changeEmailCode;
  }

  /**
   * @deprecated legacy
   */
  export async function fetchClientInfo() {
    const bitrixStore = useBitrixStore();
    return await bitrixStore.fetchClientInformation();
  }
}
